var React = require('react');

function LogoFooter (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("polygon",{"fill":"#B0E7EA","points":"17,19 43,34 17,49","key":0}),React.createElement("polygon",{"fill":"#5DC6C6","points":"17,10 17,0 52,20 17,40 17,30 35,20","key":1}),React.createElement("polygon",{"fill":"#3FB3B6","points":"26.7,24.6 17,30 17,40 35.3,29.6","key":2}),React.createElement("polygon",{"fill":"#DFE274","points":"17,30 0,20 17,10","key":3})]));
}

LogoFooter.defaultProps = {"className":"logo-footer","version":"1.1","x":"0px","y":"0px","width":"52px","height":"49px","viewBox":"0 0 52 49","enableBackground":"new 0 0 52 49","xmlSpace":"preserve"};

module.exports = LogoFooter;

LogoFooter.default = LogoFooter;
